import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, Typography, IconButton, Grid, Hidden } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { Translate } from 'react-localize-redux'
import useStyles from '../styles'
import ArticleBody from './ArticleBody'
import { DialogTitle } from './StyledComponents'

const ArticleViewDialog = ({ article, open, handleOpenClose }) => {
  const classes = useStyles()

  return (
    <Dialog open={open} onClose={handleOpenClose} fullWidth maxWidth="xl" PaperProps={{ elevation: 0 }}>
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h3">{article.title}</Typography>
        <IconButton aria-label="close" size="small" onClick={handleOpenClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Grid container className={classes.dialogContainer}>
        <Hidden only={['xs', 'sm']}>
          <Grid item md={8}>
            <Typography>
              <Translate id="time.reading-time" />:{' '}
              {typeof article.content.reading_time === 'number' &&
              article.content.reading_time !== null
                ? `${article.content.reading_time} min`
                : '-'}
            </Typography>
          </Grid>
        </Hidden>
      </Grid>
      <ArticleBody article={article} />
    </Dialog>
  )
}

ArticleViewDialog.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.shape({
      reading_time: PropTypes.number,
    }).isRequired,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  handleOpenClose: PropTypes.func.isRequired,
}

export default ArticleViewDialog
